import {
  FetchFinProductCategoriesFilters,
  FetchProductCategoriesCacheKey
} from '../../productsTypes';

import {
  FETCH_PRODUCT_STYLES_QUERY,
  FetchProductStylesQueryResponse
} from '../../queries/fetchProductStyles.query';
import { FETCH_CACHE_PRODUCT_STYLES_QUERY } from '../../queries/fetchCacheProductStyles.query';

import { useFinPaginatedCategories } from '../../../categories/hooks/useFinPaginatedCategories';

import { FetchCategoriesScopes } from '../../../categories/categoriesTypes';
import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const defaultInitialFilters = {
  scope: { eq: FetchCategoriesScopes.FACILITY_STYLES }
};
const options = {
  staleTime: 1000 * 60 * 60
};

interface ProductStylesDefaultOptions {
  cacheKey: FetchProductCategoriesCacheKey;
  addInitialFilters?: FetchFinProductCategoriesFilters;
}

function useProductStyles({
  cacheKey,
  addInitialFilters
}: ProductStylesDefaultOptions) {
  const initialFilters = addInitialFilters
    ? { ...defaultInitialFilters, ...addInitialFilters }
    : defaultInitialFilters;

  const {
    categories,
    categoriesError,
    categoriesFetched,
    categoriesIsPlaceholderData
  } = useFinPaginatedCategories<FetchProductStylesQueryResponse>({
    action: CategoriesPermissions.READ_PRODUCT_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    query: FETCH_PRODUCT_STYLES_QUERY,
    cacheQuery: FETCH_CACHE_PRODUCT_STYLES_QUERY,
    initialFilters,
    options
  });

  return {
    productStyles: categories,
    productStylesErrorMessage: categoriesError,
    productStylesFetched: categoriesFetched,
    productStylesIsPlaceholderData: categoriesIsPlaceholderData
  };
}

export default useProductStyles;
